import { useState, useEffect } from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { useOnload } from '../../hooks/useOnload';

const DESKTOP_PATH = 'M23.25 0V16A8.75 8.75 0 0032 24.75H48V23.25H32A7.25 7.25 0 0124.75 16V0H23.25ZM24.75 48V32A8.75 8.75 0 0016 23.25H0V24.75H16A7.25 7.25 0 0123.25 32V48H24.75Z';
const MOBILE_PATH = 'M15.25 0V8A8.75 8.75 0 0024 16.75H32V15.25H24A7.25 7.25 0 0116.75 8V0H15.25ZM16.75 32V24A8.75 8.75 0 008 15.25H0V16.75H8A7.25 7.25 0 0115.25 24V32H16.75Z';

export const GridBackground = (props) => {
    const { className, cellLength, cellColumns, gridWidth, gridHeight } = props;
    const breakpoint = useBreakpoint();
    const iconSize = breakpoint === 'desktop' ? 48 : 32;
    const [ iconsList, setIconsList ] = useState([]);
    const onload = useOnload();

    useEffect(() => {
        if(gridWidth && gridHeight) {
            const columns = breakpoint === 'desktop' ? cellColumns || 3 : 2
            const rows = Math.round(cellLength / columns)
            const cellSize = [ gridWidth / columns, gridHeight / rows ]
            const icons = [];
        
            for(let i = 0; i < rows + 1; i++) {
                for(let j = 0; j < columns - 1; j++) {
                    const x = cellSize[0] * (j + 1) - (iconSize / 2);
                    const y = cellSize[1] * i - (iconSize / 2);

                    icons.push(<use key={ i+'-'+j } href="#gridIcon" x={ x } y={ y } width={ iconSize } height={ iconSize } />)
                }
            }
        
            setIconsList(icons)
        }
    }, [breakpoint, cellColumns, cellLength, gridHeight, gridWidth, iconSize, onload])

    return iconsList ? (
        <svg className={ className } viewBox={ `0 0 ${ gridWidth } ${ gridHeight }` }>
            <symbol id="gridIcon" viewBox={ `0 0 ${ iconSize } ${ iconSize }` } >
                <path fill="#000" fillOpacity=".15" d={ breakpoint === 'desktop' ? DESKTOP_PATH : MOBILE_PATH } fillRule="evenodd" clipRule="evenodd" />
            </symbol>
            { iconsList }
        </svg>
    ) : null
}